import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import store from '../../../app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;
enum Status {
  loading = 'loading',
  done = 'done',
  fail = 'fail',
}

interface IRequestParams {
  title?: string;
  barcode?: string;
  vendor?: string;
  category?: string[];
  brand?: string[];
  vendorStockCode?: string;
  state?: string;
  sort?: string;
}

interface IState {
  status: Status | '';
  error: any;
  id: any;
}
const initialState: IState = {
  id: null,
  status: '',
  error: null,
};
export const exportPool = createAsyncThunk('product-pool-export/export', async (params?: IRequestParams) => {
  const vendorId = store.getState().auth?.user?.vendor?.id;
  const res = await axios.get<{ id: number }>(`${VENDOR_MC_URL}/${vendorId}/product/pool/export`, { params });
  return res.data;
});

const exportPoolSlice = createSlice({
  name: 'product-pool-export',
  initialState,
  reducers: {
    setClearId: (state) => {
      state.id = null;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(exportPool.pending, (state, action) => {
      state.status = Status.loading;
    });
    builder.addCase(exportPool.fulfilled, (state, action) => {
      state.id = action.payload.id;
      state.status = Status.done;
    });
    builder.addCase(exportPool.rejected, (state, action) => {
      state.error = 'Export List Error!';
      state.status = Status.fail;
    });
  },
});
export const { setClearId } = exportPoolSlice.actions;

export default exportPoolSlice.reducer;
